import React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatFullName } from '@utils/miscellaneous/formatFullName';
import { formatNamesReplaceSpace } from '@utils/miscellaneous/common.util';
import { IHistoricalAppInfoProps } from '../types/historicalApplication.types';

interface IAppInfoItem {
    id: string;
    value: React.ReactNode;
}

const HistoricalAppInfo: React.FC<IHistoricalAppInfoProps> = ({ data }) => {
    const {
        applicationStatus,
        applicationYear,
        applicationId,
        primaryContactFirstName,
        primaryContactLastName,
        primaryTaxFilerNames,
        financial,
    } = data;

    const APP_INFO_TO_RENDER: IAppInfoItem[] = [
        {
            id: 'common.app_status',
            value: applicationStatus,
        },
        {
            id: 'historicalApp.primary_contact',
            value: formatFullName(primaryContactFirstName, primaryContactLastName),
        },
        {
            id: 'common.primary_tax_filer',
            value: formatNamesReplaceSpace(primaryTaxFilerNames),
        },
        {
            id: 'common.coverage_year',
            value: applicationYear,
        },
        {
            id: 'common.app_id',
            value: applicationId,
        },
        {
            id: 'common.financial_application',
            value: financial ? <FormattedMessage id="common.yes" /> : <FormattedMessage id="common.no" />,
        },
    ];

    return (
        <div className="historical-application__info-grid padding-2 margin-bottom-2">
            {APP_INFO_TO_RENDER.map(({ id, value }) => (
                <div key={id}>
                    <p className="application__info-list__item__title">
                        <FormattedMessage id={id} />
                    </p>
                    <p className="application__info-list__item__content">{value}</p>
                </div>
            ))}
        </div>
    );
};

export default HistoricalAppInfo;
